module.exports = __webpack_public_path__ + "static/media/fonctionnalites_des_modules.373b0369.jpg";